import { render, staticRenderFns } from "./StepDocumentEntry.vue?vue&type=template&id=38ef16e4&"
import script from "./StepDocumentEntry.vue?vue&type=script&lang=js&"
export * from "./StepDocumentEntry.vue?vue&type=script&lang=js&"
import style0 from "./StepDocumentEntry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ef16e4')) {
      api.createRecord('38ef16e4', component.options)
    } else {
      api.reload('38ef16e4', component.options)
    }
    module.hot.accept("./StepDocumentEntry.vue?vue&type=template&id=38ef16e4&", function () {
      api.rerender('38ef16e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/external/StepDocumentEntry.vue"
export default component.exports